import {db, elasticQuery, ELASTIC_SEARCH_UPDATES_INDEX} from "../../firebase";

const Updates = db.collection('updates');

export const getUpdatesByCampaignId = campaignId=> Updates.where('cid', '==', campaignId)

export const getUpdates = ({start, size, must, must_not, aggs}) => {
    const obj = {
        model: ELASTIC_SEARCH_UPDATES_INDEX,
        body: {
            size,
            from: start * size,
            query: {
                bool: {
                    must
                },
            },
            sort: {
                date: "desc"
            },
        }
    }

    if(must_not) {
        obj.body.query.bool.must_not = must_not;
    }

    if(aggs) {
        obj.body.aggs =  aggs
    }

    return elasticQuery(obj)
}
export const getUpdatesById = id => Updates.doc(id)